module.exports = __webpack_public_path__ + "static/media/load-confirmation.1bee286a.svg";